import { base44 } from '@/api/base44Client';

/**
 * Saves a savings estimate to the SavingsEstimate entity for analytics tracking.
 * Uses sessionStorage to avoid duplicate saves within the same session.
 * 
 * @param {Object} data - Savings data to record
 */
export async function saveSavingsEstimate(data) {
  // Deduplicate within session — one save per source_page per session
  const dedupKey = `savings_saved_${data.source_page}`;
  const lastSaved = sessionStorage.getItem(dedupKey);
  const now = Date.now();
  
  // Allow re-save if competitor changed or >5 min since last save
  if (lastSaved) {
    const parsed = JSON.parse(lastSaved);
    const elapsed = now - parsed.ts;
    if (elapsed < 300000 && parsed.competitor === data.competitor_slug && parsed.total === data.total_savings_yearly) {
      return; // Skip duplicate
    }
  }

  const sessionId = sessionStorage.getItem('savings_session_id') || (() => {
    const id = `sav_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    sessionStorage.setItem('savings_session_id', id);
    return id;
  })();

  const record = {
    session_id: sessionId,
    source_page: data.source_page,
    competitor_slug: data.competitor_slug || null,
    competitor_name: data.competitor_name || null,
    total_savings_yearly: Math.round(data.total_savings_yearly || 0),
    el_savings_yearly: Math.round(data.el_savings_yearly || 0),
    laderabat_savings_yearly: Math.round(data.laderabat_savings_yearly || 0),
    smart_charge_savings_yearly: Math.round(data.smart_charge_savings_yearly || 0),
    solar_savings_yearly: Math.round(data.solar_savings_yearly || 0),
    service_agreement_savings_yearly: Math.round(data.service_agreement_savings_yearly || 0),
    payment_fee_savings_yearly: Math.round(data.payment_fee_savings_yearly || 0),
    total_kwh: Math.round(data.total_kwh || 0),
    has_ev: !!data.has_ev,
    has_solar: !!data.has_solar,
    is_eligible_laderabat: !!data.is_eligible_laderabat,
    housing_type: data.housing_type || null,
    plan_name: data.plan_name || null,
    zone: data.zone || null,
    postal_code: data.postal_code || null,
    charger_status: data.charger_status || null,
  };

  try {
    await base44.entities.SavingsEstimate.create(record);
    sessionStorage.setItem(dedupKey, JSON.stringify({ ts: now, competitor: data.competitor_slug, total: data.total_savings_yearly }));
  } catch (err) {
    console.warn('Failed to save savings estimate:', err);
  }
}